<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <CreateEditModeloProjetoModal
      v-if="showCreateEditModeloProjetoModal"
      :modeloProjetoId="modeloProjetoIdSelected"
      @closeModal="closeCreateEditModeloProjetoModal"
    />
    <LoadingData v-if="loadData" />
    <div v-else class="card">
      <div
        class="card-header d-flex justify-content-between align-items-center bg-transparent border-bottom"
      >
        <h5 class="card-title mb-0">Modelos de Projetos</h5>
        <div v-if="getModuleUserByCode('0.01.002')">
          <button
            type="button"
            class="btn btn-primary"
            title="Novo Usuário"
            @click="createEditModeloProjeto()"
          >
            Novo Modelo de Projeto
          </button>
        </div>
      </div>
      <div class="card-body">
        <ListModelosProjetos
          :modelosProjetos="modelosProjetos"
          @editModeloProjeto="createEditModeloProjeto"
        />
      </div>
    </div>
  </Layout>
</template>

<script>
import { mapGetters } from 'vuex'
import Layout from '@/views/layouts/Layout.vue'
import PageHeader from '@/components/commons/PageHeader.vue'
import LoadingData from '@/components/commons/LoadingData.vue'
import CreateEditModeloProjetoModal from '@/components/projeto/modelos/projeto/CreateEditModeloProjetoModal.vue'
import ListModelosProjetos from '../../../../components/projeto/modelos/projeto/ListModelosProjetos.vue'

export default {
  name: 'ModeloProjeto',

  components: {
    Layout,
    PageHeader,
    CreateEditModeloProjetoModal,
    LoadingData,
    ListModelosProjetos,
  },

  data() {
    return {
      title: 'Modelos de Projeto',
      items: [
        {
          text: 'Projeto',
        },
        {
          text: 'Modelos',
          active: true,
        },
        {
          text: 'Projeto',
          active: true,
        },
      ],
      loadData: true,
      showCreateEditModeloProjetoModal: false,
      modelosProjetos: null,
      modeloProjetoIdSelected: null,
    }
  },

  computed: {
    ...mapGetters(['getModuleUserByCode']),
  },

  methods: {
    async getModelosProjetos() {
      try {
        this.modelosProjetos = await this.$store.dispatch('getModelosProjetos')
        this.loadData = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$bvToast.toast(error.message, {
            title: 'Atenção!',
            variant: 'warning',
            solid: true,
          })
        } else {
          this.$root.$bvToast.toast(
            'Não foi possível se conectar ao servidor.',
            {
              title: 'Erro!',
              variant: 'danger',
              solid: true,
            },
          )
        }
      }
    },

    createEditModeloProjeto(modeloProjetoId) {
      this.modeloProjetoIdSelected = modeloProjetoId || null
      this.showCreateEditModeloProjetoModal = true
    },

    closeCreateEditModeloProjetoModal(loadListModelosProjetos) {
      if (loadListModelosProjetos) {
        this.getModelosProjetos()
      }
      this.showCreateEditModeloProjetoModal = false
    },
  },

  mounted() {
    this.getModelosProjetos()
  },
}
</script>
